import React, { useEffect, useState } from 'react';
import { RefreshCw, Package, Truck, RotateCcw, Warehouse, Inbox } from 'lucide-react';
import MainService from '../../services/MainService';

const Card = ({ title, value, icon: Icon }) => (
  <div className="rounded-lg border bg-white p-5 shadow-sm">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm text-gray-500">{title}</p>
        <p className="mt-1 text-3xl font-bold text-gray-900">{value}</p>
      </div>
      <Icon className="h-8 w-8 text-primary opacity-80" />
    </div>
  </div>
);

const WarehouseDashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      setData((await MainService.WarehouseDashboard()) || {});
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Warehouse Dashboard</h1>
          <p className="mt-1 text-sm text-gray-500">Inbound, pending, dispatched, and returned shipments</p>
        </div>
        <button type="button" onClick={load} className="inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm">
          <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} /> Refresh
        </button>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Card title="Warehouses" value={data?.WarehouseCount ?? '—'} icon={Warehouse} />
        <Card title="Inbound" value={data?.InboundCount ?? '—'} icon={Inbox} />
        <Card title="Available / Pending" value={data?.PendingCount ?? '—'} icon={Package} />
        <Card title="Available" value={data?.AvailableCount ?? '—'} icon={Package} />
        <Card title="Dispatched" value={data?.DispatchedCount ?? '—'} icon={Truck} />
        <Card title="Returned" value={data?.ReturnedCount ?? '—'} icon={RotateCcw} />
      </div>
    </div>
  );
};

export default WarehouseDashboard;
